<header id="app-header">
    <nav class="app-nav">
        <div class="nav-wrapper">
            <div>
                <a title="Start">
                    <img src="assets/images/logo-krematorium-am-limes.png" class="rtk-icon" alt="Logo">
                </a>
            </div>
            <div><!-- Spacer --></div>
        </div>
    </nav>
</header>

<main id="main" class="container">
    <div class="row main-content-row">
        <div class="col s12">
            <!-- Loading Spinner -->
            <div class="loading-container" *ngIf="isLoading">
                <div class="juvo-spinner">
                    <div class="preloader-wrapper big active">
                        <div class="spinner-layer spinner-green-only">
                            <div class="circle-clipper left">
                                <div class="circle"></div>
                            </div>
                            <div class="gap-patch">
                                <div class="circle"></div>
                            </div>
                            <div class="circle-clipper">
                                <div class="circle"></div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <!-- Error Message / Expired / Invalid GUID -->
            <div class="error-container" *ngIf="errorMessage && !isLoading">
                <div class="error-content">
                    <i class="material-icons error-icon">error_outline</i>
                    <h4 *ngIf="shouldShowExpiryMessage">Verfügbarkeitsfrist abgelaufen</h4>
                    <h4 *ngIf="!shouldShowExpiryMessage && !isAvailable">Fehler</h4>
                    <p>{{ errorMessage }}</p>
                </div>
            </div>

            <!-- Document Content -->
            <div class="document-content" *ngIf="isAvailable && !isLoading">
                <div class="document-header">
                    <div class="header-content">
                        <div class="header-title-section">
                            <h3 class="page-title">
                                <i class="material-icons">folder</i>
                                Muster-Dokumente
                            </h3>
                            <p class="page-subtitle">
                                <span class="subtitle-text">Platzhalter zum Download</span>
                            </p>
                        </div>
                        <div class="header-info" *ngIf="remainingDays > 0">
                            <i class="material-icons">event</i>
                            <span>Noch {{ remainingDays }} Tag{{ remainingDays !== 1 ? 'e' : '' }} verfügbar</span>
                        </div>
                    </div>
                    
                    <!-- Search Bar -->
                    <div class="search-container">
                        <div class="search-input-wrapper">
                            <i class="material-icons search-icon">search</i>
                            <input 
                                type="text" 
                                class="search-input" 
                                placeholder="Dokumente durchsuchen..." 
                                [(ngModel)]="searchQuery"
                                (input)="onSearchChange()"
                            />
                            <button 
                                class="search-clear-button" 
                                *ngIf="searchQuery"
                                (click)="clearSearch()"
                                title="Suche zurücksetzen"
                            >
                                <i class="material-icons">close</i>
                            </button>
                        </div>
                    </div>
                    
                    <div class="action-buttons" *ngIf="sections.length > 0">
                        <button class="redesign action download-all" (click)="downloadAllAsZip()">
                            <i class="material-icons">archive</i>
                            Alle Ordner als ZIP
                        </button>
                    </div>
                </div>

                <!-- Search Results Info -->
                <div class="search-results-info" *ngIf="searchQuery && filteredSections.length > 0">
                    <i class="material-icons">search</i>
                    <span>{{ getSearchResultsCount() }} Ergebnis{{ getSearchResultsCount() !== 1 ? 'se' : '' }} gefunden</span>
                </div>

                <!-- No Results Message -->
                <div class="no-results" *ngIf="searchQuery && filteredSections.length === 0">
                    <i class="material-icons">search_off</i>
                    <h5>Keine Ergebnisse gefunden</h5>
                    <p>Versuchen Sie es mit anderen Suchbegriffen</p>
                </div>

                <!-- Document Sections -->
                <div class="document-sections" *ngIf="filteredSections.length > 0">
                    <div class="section-card" *ngFor="let section of filteredSections">
                        <div class="section-header" (click)="toggleSection(section.id)">
                            <div class="section-title-wrapper">
                                <button class="expand-button" (click)="toggleSection(section.id); $event.stopPropagation()">
                                    <i class="material-icons">{{ isSectionExpanded(section.id) ? 'expand_less' : 'expand_more' }}</i>
                                </button>
                                <div class="folder-icon-wrapper">
                                    <i class="material-icons folder-icon">{{ isSectionExpanded(section.id) ? 'folder_open' : 'folder' }}</i>
                                </div>
                                <div class="section-title-content">
                                    <h5 class="section-title">{{ section.title }}</h5>
                                    <span class="document-count">{{ section.documents.length }} Dokument{{ section.documents.length !== 1 ? 'e' : '' }}</span>
                                </div>
                            </div>
                            <button class="section-zip-button" (click)="downloadSectionAsZip(section); $event.stopPropagation()" title="Ordner als ZIP herunterladen">
                                <i class="material-icons">archive</i>
                                ZIP
                            </button>
                        </div>
                        
                        <div class="document-list" *ngIf="isSectionExpanded(section.id)">
                            <div class="document-item" *ngFor="let doc of section.documents" (click)="downloadDocument(doc)">
                                <div class="document-item-content">
                                    <div class="document-icon">
                                        <i class="material-icons">picture_as_pdf</i>
                                    </div>
                                    <div class="document-details">
                                        <span class="document-title-text">{{ doc.title }}</span>
                                        <span class="document-filename">{{ doc.filename }}</span>
                                    </div>
                                    <div class="document-actions">
                                        <i class="material-icons download-indicator">file_download</i>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                <!-- Empty State -->
                <div class="empty-state" *ngIf="sections.length === 0">
                    <i class="material-icons">folder_open</i>
                    <h5>Keine Dokumente verfügbar</h5>
                </div>
            </div>
        </div>
    </div>
</main>

<!-- Footer -->
<footer class="page-footer">
    <div class="footer-content">
        <span class="footer-text">geteilt mit</span>
        <a href="https://KremaSoft.de" target="_blank" rel="noopener noreferrer" class="footer-link">
            KremaSoft
        </a>
    </div>
</footer>

